var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStackingIcon2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\xD0\xA0\xD0\x8E\xD0\xA0\xC2\xBB\xD0\xA0\xD1\x95\xD0\xA0\xE2\x84\x96_1",
    clipPath: "url(#clip0_3_94282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30 0H4C1.79086 0 0 1.79086 0 4V30C0 32.2091 1.79086 34 4 34H30C32.2091 34 34 32.2091 34 30V4C34 1.79086 32.2091 0 30 0Z",
    fill: "#E8E8F7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.08 14.3101V23.2001",
    stroke: "#09363F",
    strokeWidth: 1.36,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M21.77 10.8999H23.1C24.66 10.8999 25.92 12.1599 25.92 13.7199V23.1999",
    stroke: "#09363F",
    strokeWidth: 1.36,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M8.24005 23.1999V13.7199C8.24005 12.1599 9.50005 10.8999 11.0601 10.8999H12.3901",
    stroke: "#09363F",
    strokeWidth: 1.36,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M17.0801 28.16C18.0245 28.16 18.7901 27.3944 18.7901 26.45C18.7901 25.5056 18.0245 24.74 17.0801 24.74C16.1356 24.74 15.3701 25.5056 15.3701 26.45C15.3701 27.3944 16.1356 28.16 17.0801 28.16Z",
    fill: "#09363F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M9.95003 26.45C9.95003 27.39 9.19003 28.16 8.24003 28.16C7.29003 28.16 6.53003 27.4 6.53003 26.45C6.53003 25.5 7.29003 24.74 8.24003 24.74C9.19003 24.74 9.95003 25.5 9.95003 26.45Z",
    fill: "#09363F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M25.93 28.16C26.8744 28.16 27.64 27.3944 27.64 26.45C27.64 25.5056 26.8744 24.74 25.93 24.74C24.9856 24.74 24.22 25.5056 24.22 26.45C24.22 27.3944 24.9856 28.16 25.93 28.16Z",
    fill: "#09363F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M17.37 5.77002L18.23 7.60002C18.28 7.70002 18.37 7.77002 18.48 7.78002L20.48 8.03002C20.75 8.06002 20.86 8.40002 20.66 8.58002L19.19 9.96002C19.11 10.04 19.07 10.15 19.09 10.26L19.47 12.24C19.52 12.51 19.24 12.71 19 12.58L17.23 11.61C17.13 11.56 17.02 11.56 16.92 11.61L15.15 12.58C14.91 12.71 14.63 12.51 14.68 12.24L15.06 10.26C15.08 10.15 15.04 10.04 14.96 9.96002L13.49 8.58002C13.29 8.39002 13.4 8.06002 13.67 8.03002L15.67 7.78002C15.78 7.77002 15.87 7.70002 15.92 7.60002L16.78 5.77002C16.9 5.52002 17.25 5.52002 17.36 5.77002H17.37Z",
    fill: "#09363F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_94282"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackingIcon2);
export default __webpack_public_path__ + "static/media/stacking_icon2.7053eae6bae3a1836f44d52a57f0ccee.svg";
export { ForwardRef as ReactComponent };